import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import Sidebar from '../Sidebar'


class BlogItem extends Component {
	render() {
		return (
			<div>
				<Header
					bg="none"
					image={require('./image-5.jpg')}
					title={"10 Takeaways From State of Social '20"}
				/>
				<div className="entry-content">
					
					<div className="container">
						<h2 className="blog-details">
								<div className="author-circle lauren"></div>
								<div className="line"></div>
								<div className="title">
									Written by <strong>Lauren</strong> on 27 Nov 2020  //  Posted in <strong>Marketing</strong>
								</div>
						</h2>
						
						<div className="row">
							<div className="col-lg-7">
								<div className="tagline">
									The Social Dilemma? Or the Social Revolution?
								</div>
<h3>Our 10 Key Takeaways from State of Social '20.</h3>
								
								<p>Amidst the chaos and calamity that was COVID-19 in 2020, the thought of ANY of the Moshi team attending an event seemed pretty unrealistic. </p>
								
								<p>And then we reached November - the State of Social ‘20 had been rescheduled and was announced to be still going ahead, bringing numerous experts in the fields of marketing, social media, Google Ads, photography, copywriting (and more!) together through the magic of technology and Zoom. </p>

<img src={require('./image-2.jpg')} alt="Kate Walsh speaking at the State of Social '20 Convention" height="200" className="align-right" align="right" />

<p>The State of Social ‘20 event had some pretty impressive keynote speakers, including <a href="https://stateofsocial.com.au/speaker/meg-coffey/">Meg Coffey</a> (from Coffey & Tea), <a href="https://stateofsocial.com.au/speaker/kate-walsh/">Kate Walsh</a> (Grey’s Anatomy, Umbrella Academy), <a href="https://stateofsocial.com.au/speaker/tom-goodwin/">Tom Goodwin</a> (Digital Darwinism author), <a href="https://stateofsocial.com.au/speaker/lauren-quaintance/">Lauren Quaintance</a> (of Storyation),  <a href="https://stateofsocial.com.au/speaker/matthew-kobach/">Matthew Kobach</a> (from Fast), <a href="https://stateofsocial.com.au/speaker/Fabienne-sharbanee/">Fabienne Sharbanee</a> (from Bennett + Co), <a href="https://stateofsocial.com.au/speaker/jenn-herman/">Jenn Herman</a> (Instagram expert),  <a href="https://stateofsocial.com.au/speaker/Seva-Mozhaev/">Seva Mozhaev</a> (TikTok superstar), <a href="https://stateofsocial.com.au/speaker/justin-dry/">Justin Dry</a> (VinoMoFo), <a href="https://stateofsocial.com.au/speaker/gabe-mach/">Gabe Mach</a> (Bonfire), <a href="https://stateofsocial.com.au/speaker/gavin-carver/">Gavin Carver</a> (88 Astronauts) and so many more. </p>

<p>Dee (our Creative Producer) and I attended the event to learn a few things:</p>

<ul class="with-icons">
<li>If we are giving our customers the best possible social media strategies available (quick answer - yes!), and
</li>
<li>What we should keep an eye out for in 2021 in terms of trends and technology. </li>
</ul>

<h3>So without further ado, here are my top 10 takeaways from the industry’s experts about social media.</h3>
<br></br>
<h2>TAKEAWAY 1: ALWAYS REMEMBER YOUR ‘WHY’</h2>
<p>This was brought up so many times, and it’s something I tell all of my social media clients.
Before you begin ANY kind of social media strategy, you should know the answer to this question: “Why should someone follow me?”</p>

<p>Start with the sentence ‘People should follow me because…..” and then write down as many answers as you can until you nail your unique selling point - what makes you different from everyone else in the competition. Once you know WHY people should follow you, you can base content ideas around these points of difference - staying interesting, educational, and (most importantly) relevant to your audience. </p>

<p>This brings us to takeaway point number 2. </p>
<br></br>

<h2>TAKEAWAY 2: AUDIENCE MATRIXES - MAKE MESSAGING EASY!</h2>

<p>Save yourself time and effort by creating an Audience Matrix. Bonfire Marketing brought this up on Day 2 of State of Social, and I couldn’t agree more. An Audience Matrix will make it easy to choose your messaging, creative, platform and offer for your brand’s campaign. </p>

<p>Start by working out who your campaign is aiming to reach: </p>
<ul>
<li>people who don’t know anything about your brand </li>
<li>people who are aware they have a problem but don’t know about you </li>
<li>people who know the solution exists but don’t know where to look</li>
<li>people who are aware of your product or service but not how they can use it</li>
<li>and lastly, the people who are most aware </li>
</ul> 

<p>From there, use your analytics or qualitative research to align each audience type to their ideal platform, messaging, creative, and what offer you need to show them to get them on board.
Next time you have a campaign to run, simply look back over your Matrix! Voila - an instant time saver. </p>

<h3>An example of how to set up your matrix:</h3>

<img src={require('./matrix.png')} alt="Audience Matrix example" className="align-centre" align="centre" />

<br></br>
<br></br>
<h2>TAKEAWAY 3: INTRODUCTION OF INSTAGRAM GUIDES AND GOOGLE LENS</h2>
<p>Instagram Guides has been talked about for a while, but now it’s finally here for business accounts in Australia. Guides seems to be like a mini directory you can keep on your profile - for the most part it appears to be the lovechild of Pinterest and a much more convenient Linkin bio.</p>  
<img src={require('./insta-guides.jpg')} alt="The location of instagram Guides on your profile" height="500" className="align-centre" align="centre" />
<p>Essentially, you have the option to pin posts that you’ve created or saved related to similar topics, recommend local places, or recommend products. Is this the start of Instagram becoming a mini Google? Only time will tell how popular this new feature will become, but I for one can’t wait to see it picked up by more businesses in 2021!</p>

<p> Google Lens is also soon to be introduced - a new form of ecommerce shopfront with a chance to grow the customer experience into expanding into 3D and augmented reality. We'll post more as we find out!</p>

<br></br>
<h2>TAKEAWAY 4: STORIES AND REELS ARE KING - THE FEED IS DYING</h2>
<p>This has been a trend gaining momentum for the last few years, but it seems to be accelerating. People are turning more to Stories, IGTV, Reels, TikTok and other short form video formats instead of the traditional ‘feed’ items. The feed is still popular and will still get you engagement with a strategic boost here or there, but these short snippets of content are perfect for time poor people on the run, people looking for quick answers, or wanting short snippets of entertaining content.</p>
<img src={require('./TT.gif')} alt="Short form video via TikTok" height="300" className="align-left" align="left" />
<p>If you’re lying in bed just about to go to sleep, are you flicking through Stories or wading through ads on your feed?</p>
<p><b>
That’s what I thought! </b></p>

<p>But if you are a fan of creating content for your feed as opposed to short videos, just make sure your content is high quality, and will ‘stop the scroll’. </p>
<p> And while we're on the topic of content, nearly every speaker at State of Social reaffirmed the importance of storytelling. Your content should be relatable, empathetic and personal for maximum engagement.</p>
<br></br>
<br></br>
<h2>TAKEAWAY 5: PRIORITISE YOUR AD SPEND BY SETTING UP THE BASICS CORRECTLY</h2>
<p>Gabe from Bonfire really cemented this in the morning workshop for Day 2 of State of Social. There are a few things you can do to make sure your campaigns are going to be tracked properly and running smoothly - but of course, if you're with Moshi we do all this for you. </p>

<ul><p>
<li>Install <b>Google Tag Manager</b> (if you are being managed by Moshi, we already have that set up!)</li>
<li>Insert your Google code into the correct pages of your site, setting up <b>‘Triggers’ and ‘Events’</b> in Google Analytics as you go. </li>
<li>Install your <b>Facebook Pixel </b>on your website, and make sure it’s tracking conversions correctly. </li>
<li>Review your website’s SEO to make the <b>landing experience</b> for your end user is as good as it can be. This improves your Google Ad Rank and improves conversion rates. </li>
<li>Set up Audiences in your Facebook Ads Manager BEFORE you run your campaigns - this means creating <b>Lookalike Audiences and Custom Audiences.</b></li>
</p></ul>

<p>There are a plethora of steps I could give you here! If you need a hand with any set up, you can always contact the team <a href="https://www.moshi.com.au/contact-us">here!</a></p>

<br></br><br></br>
<h2>TAKEAWAY 6: SPLIT TEST, SPLIT TEST, SPLIT TEST!</h2>
<p>How to make the most of your budget? <b>Split test.</b></p>
<p>This means that your audience are shown variants of the same ad, with copy, creative, caption or call to action being interchanged until Google or Facebook work out which of these combinations is resulting in the most click throughs.</p>

<p>The winning combination then gets allocated the bulk of your budget, meaning that while all this machine learning is going on, you can sit back and relax!</p>



<br></br><br></br>
<h2>TAKEAWAY 7: INSTAGRAM SEO - YES, IT EXISTS</h2>
<p>It may seem silly, but your bio, headline, username and feed could well be holding you back from being found by your audience. </p>
<p><b>HEADLINE AND USERNAME:</b> Your username should be easily recognisable and reflect your business.</p>

<p><b>PROFILE PICTURE:</b> This doesn’t have to be your logo! Pick something iconic to your brand, that’s easily recognisable in a small circle. Centre if you can! </p>

<p><b>BIO:</b> the first four lines are all that people can see in your bio before they have to press ‘see more’. Make them count! Bullet points are great, as are emojis and Google Keywords. Using keywords in your bio makes it easier for people to find you in Search. Bam! </p>

<p><b>FEED:</b> feeds that are themed still perform well, but feeds that offer authentic, REAL content perform the best. Take the time to figure out what’s more important to your brand - highly polished or real? Maybe you can do both? But one thing goes without saying - use high quality photos, videos, gifs or cinemagraphs. </p>
<h3>Want to learn more? We have a whole Highlight Reel of social media tips on our Instagram profile. <a href="https://www.instagram.com/moshimoshimarketing/">Follow Us</a> for weekly tips!</h3>
<img src={require('./SEOprofile.jpg')} alt="InstagramSEO is a real thing!" height="350" className="align- centre" align="centre" /> 


<br></br><br></br>
<h2>TAKEAWAY 8: POST, EXPERIMENT, REVIEW, REPEAT.</h2>
<p>Matthew Kobach from Fast brought up the importance of constantly testing. And failing. And testing. And succeeding! 
</p>
<p>To find out what works with your target market, he suggests creating extremely niche content, and posting DAILY. Then, when you have enough data to see what’s really connecting with people, you can expand your niche content slightly and post a little less. He still recommends posting at least three times a week (the golden number!), but ONLY after experimenting with content ideas to find what really resonates with your fans.</p>
<p> Gavin Carver from 88 Astronauts also brought up this valuable piece of advice when it comes to content: "Design for sound off, but build for sound on". Most people have their sound off on their phones, to use audio to add value, not to be the prime selling point.</p>



<br></br><br></br>
<h2>TAKEAWAY 9: DON’T PIGEONHOLE NEW PLATFORMS</h2>
<p>This really hit home. Hands up how many of you reading this haven’t even so much looked at TikTok as a viable marketing option because ‘it’s for kids’?</p>
<p>Ok, now how many of you secretly have the app downloaded and view it almost daily but are too embarrassed to say anything? Mmmhmmm. Me too.</p>

<p>Perth’s very own school teacher turned TikTok celebrity, Seva Mozhaev provided a keynote presentation that really made me take a look at the social prejudice against TikTok. He highlighted the importance of not brushing off a social platform because of social opinion, and as he pointed out, at the start of Instagram being launched everyone thought it was only for Millennials - now look at the empire! His words of advice? Jump onto TikTok while it’s still hot. And don’t be embarrassed!</p>
<img src={require('./image-3.jpg')} alt="Meg Coffey speaking at State of Social '20.All photos from State of Social Facebook page" height="350" className="align- centre" align="centre" /> 



<br></br><br></br>
<h2>TAKEAWAY 10: DON’T STRESS - SOCIAL PLATFORMS AREN’T ACTUALLY LISTENING TO YOU</h2>
<p>More of an urban myth than a takeaway point, but the fact is that despite the rumours, <b>Facebook and Instagram are NOT secretly listening to your conversations to serve you advertising</b>. Good, we can all relax!</p>
<img src={require('./image-4.jpg')} alt="The great debate on whether social media is negatively impacting people's mental health,  run by Youngbloods WA.All photos from State of Social Facebook page" height="350" className="align- centre" align="centre" /> 

<p>This was raised by Gabe from Bonfire, who made the extremely wise and valid point that Facebook and Instagram have such an in-depth understanding of your behaviours, preferences, buying habits, and search history already that they don’t have to listen to us to know what we’re talking about. And this is thanks to Google’s products all collating our information to create crazy accurate user profiles for us all. If you’ve ever used Google, Youtube, Android products, Google Images, News, Gmail, Calendar, Drive, Photos, Maps, Translate….  If you’ve ever picked up a phone, you’ve given the internet information about you.</p>

<p>So still slightly creepy, but rest in peace that the secrets you’re telling your friend in the room will stay between you two…. And if not, you know who to blame!
</p>
<br></br>
<h2>So get posting!</h2>
<img src={require('./image-6.jpg')} alt="Lauren Dixon and Dee Mosca from Moshi Moshi Marketing at State of Social '20" height="300" className="align- right" align="right"/> 
<p><a href="https://stateofsocial.com.au">State of Social '20</a> was a great event, and I hope you’ve learned from the 10 key lessons we pulled from these amazing industry experts. And remember, if you need a hand with social strategy, analytics, campaign management or content creation, you can always get in touch with our expert team <a href="https://www.moshi.com.au/contact-us">here</a>.</p>









							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-4">
								<Sidebar />
							</div>
						</div>
					</div>
				</div>

			</div>
		);
	}
}

export default BlogItem;


// WEBPACK FOOTER //
// ./src/Pages/Blog/StateofSocial/index.js